import { createAction, props } from '@ngrx/store';
import { Institution } from 'src/generated/graphql';
import { InstitutionsFilter } from '../../models/institutions-filter';

export const searchInstitutions = createAction('[Institutions] search institutions');
export const searchInstitutionsSuccess = createAction(
  '[Institutions] search institutions success',
  props<{ institutions: Institution[]; total: number }>()
);

export const setFilterInput = createAction(
  '[Institutions] set filter input',
  props<{ filterInput: InstitutionsFilter }>()
);

export const updateFilterInput = createAction(
  '[Institutions] update filter input',
  props<{ filterInput: InstitutionsFilter }>()
);

export const setSearchTerm = createAction(
  '[Institutions] set search term',
  props<{ searchTerm: string }>()
);
